// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"449":"07fa8c0a","453":"d67f9adb","488":"c3179ed1","833":"8fce5185"}[chunkId] + ".chunk.js";
};